<template>
  <transition name="slide-pageTransition" mode="out-in">
    <div class="wrapper">
      <h1>ЭТО СТРАНИЦА АДМИНИСТРАТОРА</h1>
      <h2>Вы зашли как: {{fio}}</h2>
      <button class="btn danger" @click.prevent="logout">Выйти</button>
      <app-page title="Создать нового пользователя">
        <template #header>
          <button class="btn primary" @click.prevent="modal = true"> Создать </button>
        </template>

        <teleport to="body">
          <request-modal v-if="modal" title="Создать пользователя" @close="modal = false">
            <create-user @created="modal = false"></create-user>
          </request-modal>
        </teleport>

      </app-page>
      <app-page title="Список заявок на обслуживание">
        <template #header>
          <button class="btn primary" @click.prevent="loadRequests">Загрузить</button>
        </template>

        <request-filter v-model="filter"> </request-filter>
        <service-table :requests="requests"> </service-table>
      </app-page>
      <app-page title="Список пользователей">
        <template #header>
          <button class="btn warning" @click.prevent="unloadUsers">Выгрузить</button>
          <button class="btn primary" @click.prevent="loadUsers">Загрузить</button>
        </template>

        <request-filter v-model="userFilter"> </request-filter>
        <user-table :users="users"> </user-table>
      </app-page>
    </div>
  </transition>
</template>

<script>

import {useRouter} from 'vue-router'
import {useStore} from 'vuex'
import AppPage from "@/components/backend/AppPage";
import RequestFilter from "@/components/ui/RequestFilter";
import ServiceTable from "@/components/backend/ServiceTable";
import UserTable from "@/components/backend/UserTable";
import RequestModal from "@/components/ui/RequestModal";
import UserBody from "@/components/ui/UserBody";
import createUser from "@/components/ui/createUser";
import {ref, computed} from "vue";


export default {
  components: {AppPage, ServiceTable, UserTable, RequestFilter, RequestModal, UserBody, createUser},
  setup() {
    const router = useRouter()
    const store = useStore()

    const modal = ref(false)

    const fio = store._state.data.auth.loginData.name

    const requests = computed(() => store.getters['request/requests']
    .filter(request => {
      if (filter.value.name) {
        return request.name.includes(filter.value.name)
      }
      return request
    })
    .filter(request => {
      if (filter.value.contract) {
        return request.contract.includes(filter.value.contract)
      }
      return request
    })
    .filter(request => {
      if (filter.value.phone) {
        return request.phone.includes(filter.value.phone)
      }
      return request
     })
    )
    const registrations = computed(() => store.getters['request/registrations'])
    const users = computed(() => store.getters['request/users']
        .filter(user => {
          if (userFilter.value.name) {
            return user.name.includes(userFilter.value.name)
          }
          return user
        })
        .filter(user => {
          if (userFilter.value.contract) {
            return user.contract.includes(userFilter.value.contract)
          }
          return user
        })
        .filter(user => {
          if (userFilter.value.address) {
            return user.address.includes(userFilter.value.address)
          }
          return user
        })
        .filter(user => {
          if (userFilter.value.phone) {
            return user.phone.includes(userFilter.value.phone)
          }
          return user
        })
        .filter(user => {
          if (userFilter.value.valid) {
            return user.validity.startsWith(userFilter.value.valid)
          }
          return user
        })
        .filter(user => {
          if (userFilter.value.trest) {
            return user.trest.includes(userFilter.value.trest)
          }
          return user
        })
    )
    const filter = ref({})
    const userFilter = ref({})


    return {
      fio,
      requests,
      registrations,
      users,
      filter,
      userFilter,
      modal,
      logout: () => {
        store.commit('auth/logout')
        store.commit('clearMessage', null, {root: true})
        store.dispatch('auth/logout', null, {root: true} )
        store.dispatch('setMessage', {
          value: 'Вы вышли из аккаунта',
          type: 'warning'
        }, {root: true})
        router.push('/auth')
      },
      loadRequests: () => {
        store.dispatch('request/getRequests', null, {root: true})
      },
      loadUsers: () => {
        store.dispatch('request/getAuthUsers', null, {root: true})
      },
      unloadUsers: () => {
        const myUsers = users._value
        myUsers.map(function(obj) {
          delete obj.creator
          delete obj.creationDate
          delete obj.__v
          delete obj._id
          delete obj.password
          delete obj.roles
      })
        store.dispatch('request/createExcel', myUsers, {root: true})
        store.dispatch('request/getAuthUsers', null, {root: true})
      }
    }
  }
}

</script>

<style scoped>

.wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px;
}

h1, h2 {
  text-align: center;
}

button {
  margin: 15px;
}

</style>